import { Controller } from "@hotwired/stimulus"

// The hero's "lights out in" numeral.
//
// Ticks once a second while the event is more than a minute away and once a
// second inside the final hour; there is no cheaper cadence worth the branch.
// Under `prefers-reduced-motion` it still updates: a countdown that does not
// count is not motion, it is broken, but nothing animates.
export default class extends Controller {
  static targets = ["output"]
  static values = { startsAt: String }

  connect() {
    this.render()
    this.timer = setInterval(() => this.render(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  render() {
    const target = Date.parse(this.startsAtValue)
    if (Number.isNaN(target)) return

    const remaining = target - Date.now()

    if (remaining <= 0) {
      this.outputTarget.textContent = "LIVE"
      clearInterval(this.timer)
      return
    }

    const totalSeconds = Math.floor(remaining / 1000)
    const days = Math.floor(totalSeconds / 86400)
    const hours = Math.floor((totalSeconds % 86400) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    // Days are only shown while they matter; inside 24 hours the numeral
    // becomes a clock, which is what the reader actually needs by then.
    this.outputTarget.textContent =
      days > 0
        ? `${days}d ${this.pad(hours)}:${this.pad(minutes)}`
        : `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`
  }

  pad(value) {
    return String(value).padStart(2, "0")
  }
}
